import React from 'react';
import { ConfigureCaseListTable } from '../../components/CaseList/CaseListTable';
import { listInitialStateDefaults } from '../../helpers/constants';
import { surgeonMessages } from '../../helpers/messages';
import { caseListService, deleteCaseService } from '../../services/java/java-services';
import ExportData from './ExportData';

export default function CaseListTableContainer(props) {
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [actionLoading, setActionLoading] = React.useState(false);
    const [pageCount, setPageCount] = React.useState(0);
    const [totalCount, setTotalCount] = React.useState(0);
    const [errorObj, setErrorObj] = React.useState(null);
    const [actionErrorObj, setActionErrorObj] = React.useState(null);
    const [refreshList, setRefreshList] = React.useState(false);
    const [showExportButton, setShowExportButton] = React.useState(false);
    const [actionSuccessMsg, setActionSuccessMsg] = React.useState('');
    const { pageIndex, pageSize, sortBy } = props.propState;
    const initialState = {
        pageIndex: pageIndex || listInitialStateDefaults.pageIndex,
        pageSize: pageSize || listInitialStateDefaults.pageSize,
        sortBy: sortBy || listInitialStateDefaults.sortBy,
        hiddenColumns: props.hiddenColumns ? props.hiddenColumns : listInitialStateDefaults.hiddenColumns
    };

    /**
     * @description Function to set up fetch call
     * @param params Object with page number, sort order, sort by column and page size
    */
    const fetchData = React.useCallback(
        ({ pageSize, pageIndex, sortBy, pageOptions }) => {
            let columnSortBy = "dateOfSurgery"; // default
            let sortOrder = "desc"; // default
            let keyMapping = {};
            keyMapping = {
                "caseDetails.caseID": "caseID",
                "caseDetails.dateOfSurgery": "dateOfSurgery",
                "caseDetails.operativeProcedure": "operativeProcedure",
                "caseDetails.finalImplantDesign": "finalImplantDesign",
                "caseDetails.sex": "sex",
                "caseDetails.patientName": "patientName",
                "caseDetails.patientage": "patientage",
                "caseDetails.surgeonName": "surgeonName",
                "caseDetails.operativeSide": "operativeSide",
                "caseDetails.operativeApproach": "operativeApproach"
            };

            if (sortBy[0]) {
                columnSortBy = Object.keys(keyMapping).length ? keyMapping[sortBy[0].id] : sortBy[0].id;
                sortOrder = sortBy[0].desc ? "desc" : "asc";
            }

            var urlParams = {
                pageno: pageIndex + 1,
                sortorder: sortOrder,
                column: columnSortBy,
                limit: pageSize
            }

            for (const key in props.filterObj) {
                if (props.filterObj.hasOwnProperty(key) && (props.filterObj[key] || props.filterObj[key] === 0)) {
                    if (!(key === 'proceduretype' && props.filterObj[key] === 'all')) {
                        urlParams[key] = props.filterObj[key];
                    }
                }
            }

            setLoading(true);
            setErrorObj(null);
            setShowExportButton(false);

            caseListService(urlParams,
                (err, result) => {
                    if (err) {
                        setLoading(false);
                        setErrorObj(err);
                    } else {
                        let getMetadata = result?.data?.case;
                        let getTotalCount = result?.data?.response_metadata?.total;
                        let pageCount = Math.ceil(getTotalCount / pageSize);
                        setData(getMetadata);
                        setPageCount(pageIndex !== 0 && pageOptions?.length > pageCount ? pageOptions?.length - 1 : pageCount);
                        setTotalCount(getTotalCount);
                        setErrorObj(null);
                        setLoading(false);
                        setShowExportButton(props?.filterObj?.proceduretype && getMetadata.length > 0);
                    }
                }
            );
        },
        [props]
    );

    /**
     * @description Function to call case delete API
     * @param caseDetails Case details row element
     */
    const deleteCase = (caseDetails) => {
        setActionLoading(true)
        deleteCaseService(caseDetails?.caseDetails?.caseID, (err, res) => {
            if (err) {
                setActionErrorObj(err);
                setActionLoading(false);
            } else {
                setActionErrorObj(null);
                setActionLoading(false);
                setRefreshList(true);
                setActionSuccessMsg(surgeonMessages.caseDeleteSuccess);
                setTimeout(() => {
                    setRefreshList(false);
                }, 0);
                setTimeout(() => {
                    setActionSuccessMsg('');
                }, 5000);
            }
        })
    }

    return (
        <>
            {showExportButton ? <ExportData filterObj={props?.filterObj} /> : ''}
            <ConfigureCaseListTable
                initialState={initialState}
                columns={props.columns}
                data={data}
                fetchData={fetchData}
                actionErrorObj={actionErrorObj}
                loading={loading}
                actionLoading={actionLoading}
                pageCount={pageCount}
                totalCount={totalCount}
                showPagination={props.showPagination}
                disableColmSort={props.disableColmSort}
                filterObj={props.filterObj}
                errorObj={errorObj}
                refreshList={refreshList}
                deleteCase={deleteCase}
                actionSuccessMsg={actionSuccessMsg}
            />
        </>
    )
}
